import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function NewPropertiesOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M13.6023 5.91902L11.957 4.65294L13.4858 3.50637C13.9355 3.16911 14.4695 3 15.0034 3C15.5374 3 16.0714 3.16862 16.5211 3.50588L22.0034 7.61764V18.9966L17.5003 18.9967V16.9961H20.0034V8.61764L15.3211 5.10588C15.227 5.03529 15.1152 5 15.0034 5C14.8917 5 14.7799 5.03578 14.6858 5.10637L13.6023 5.91902Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9.62594V21.0049L16 21.0044V9.62545L10.5176 5.51369C10.068 5.17644 9.53399 5.00781 9 5.00781C8.46601 5.00781 7.93203 5.17693 7.48235 5.51418L2 9.62594ZM14 10.6255L9.31765 7.11369C9.22353 7.04311 9.11177 7.00781 9 7.00781C8.88823 7.00781 8.77647 7.04359 8.68235 7.11418L4 10.6259V19.0039H14V10.6255Z",
    fill: "currentColor"
  }));
}